import React from "react";
import {T} from "@tolgee/react";
import LoginLink from "view/SignUp/SignUpToken/components/LoginLink";

type Props = {
  email: string;
  /** A Google address cannot be typed away, so the copy offers another account. */
  isFromGoogle: boolean;
};

const EmailInUseByAnotherRole = ({email, isFromGoogle}: Props) => (
  <T
    keyName={
      isFromGoogle
        ? "global.sign_up.error.email_in_use_by_another_role"
        : "global.sign_up.error.email_in_use_by_another_role_login"
    }
    params={{email, login: <LoginLink />}}
  />
);

export default EmailInUseByAnotherRole;
